module.exports = __webpack_public_path__ + "assets/img/22_361.1a01e614.jpg";